import { FieldArray, useFormikContext } from 'formik';
import { Fragment, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../../../../components/SectionHeader';
import EditVehicleImageItem from './EditVehicleImageItem';
import Button from '../../../../components/buttons/Button';

export default function EditVehicleImage({ title }: { title: string }) {
  const formRef = useRef(null);
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(0);
  const formik = useFormikContext<any>();

  return (
    <div className={'model_gallery model_exterior_images'} ref={formRef}>
      <SectionHeader title={title}>
        <div style={{ paddingBottom: '2rem' }}>
          <div className="accordions-container">
            {formik?.values?.images?.map((item: any, index: number) => {
              return <EditVehicleImageItem data={item} expanded={expanded} setExpanded={setExpanded} index={index} />;
            })}
            {!formik.values?.images?.length && !formik.values?.new_images?.length && <h6>{t('no_images_found')}</h6>}
            <FieldArray
              name="new_images"
              render={(arrayHelpers) => (
                <Fragment>
                  {formik?.values?.new_images?.map((_: any, index: number) => {
                    return <EditVehicleImageItem expanded={expanded} arrayHelpers={arrayHelpers} setExpanded={setExpanded} add index={index} />;
                  })}
                  <div className="form_button reverse">
                    <Button type="button" onClick={() => arrayHelpers.push([])}>
                      <span className="bold">{t('add_image')}</span>
                    </Button>
                  </div>
                </Fragment>
              )}
            />
          </div>
        </div>
      </SectionHeader>
    </div>
  );
}
